import { useAnalytics } from '@/hooks/useAnalytics';

export const AnalyticsProvider = ({ children }: { children: React.ReactNode }) => {
  // Initialize analytics tracking
  useAnalytics();
  
  // Component doesn't render anything visible
  return <>{children}</>;
};